import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ZoomIntoViewText = styled.p`
  position: absolute;
  color: var(--text-soft);
  transform: translate(-50%, -100%);
  ${typographyV2.bodySm};
`;
